import { render, staticRenderFns } from "./SeasonBox.vue?vue&type=template&id=4a2dfd2e&"
import script from "./SeasonBox.vue?vue&type=script&lang=js&"
export * from "./SeasonBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports